import { useSelector } from "react-redux";
import today from "../../../Artifacts/Todaysretail.png";
import total from "../../../Artifacts/TotalRetail.png";
import totallmtd from "../../../Artifacts/total LMTD.png";
import lmtd from "../../../Artifacts/LMTD.png";
import { PriKPI } from "../../../Components/KPI/PriKPI";
import { useQuery } from "@tanstack/react-query";
import {
  invoice_details,
  todays_retail,
  total_retail,
  lmtdretail,
  total_retail_lmsd,
} from "./apiforkpi";
import { TbFilterDown } from "react-icons/tb";
import { useState } from "react";
import RetailFilter from "../../../Components/Filters/RetailFilter";
import { RetailTableDetailed } from "../RetailDetail/RetailTableDetailed";
import RetailBreakupKPI from "../../../Components/KPI/RetailBreakupKPI";

export const KPI = () => {
  const { data, submitted } = useSelector((state) => state.filters);
  const [isFormVisible, setFormVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data: tdyRetail } = useQuery({
    queryKey: ["todaysretail", submitted],
    queryFn: () => todays_retail(data),
    initialData: [],
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const { data: ttlRetail } = useQuery({
    queryKey: ["total_retail", submitted],
    queryFn: () => total_retail(data),
    initialData: [],
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const { data: invoice } = useQuery({
    queryKey: ["invoice_details", submitted],
    queryFn: () => invoice_details(data),
    initialData: [],
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const { data: lmtd_retail } = useQuery({
    queryKey: ["lmtd_retail", submitted],
    queryFn: () => lmtdretail(data),
    initialData: [],
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const { data: totalretaillmsd } = useQuery({
    queryKey: ["total_retail_lmsd", submitted],
    queryFn: () => total_retail_lmsd(data),
    initialData: [],
    refetchInterval: 300000,
    refetchIntervalInBackground: true,
  });

  const toggleForm = () => {
    setFormVisible(!isFormVisible);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  return (
    <div className="flex flex-col gap-2 ">
      {isFormVisible && (
        <RetailFilter
          isFormVisible={isFormVisible}
          setFormVisible={setFormVisible}
        />
      )}
      <div className="flex gap-2  md:flex-row flex-col-reverse">
        <section className="grid grid-cols-2 gap-2 md:grid-cols-3 lg:grid-cols-6 md:w-[95%] w-full">
          {/* 1 */}
          <PriKPI
            Image={today}
            Alt={"Today's Retail"}
            ColorDark="bg-gradient-to-b from-[#FFE700] to-[#F9A526] col-span-1"
            Title={"Today's Retail"}
            Value={tdyRetail || 0}
            Padding={"p-2"}
            ImageSize={"w-9"}
          />

          {/* 2 */}
          <PriKPI
            Image={lmtd}
            Alt={" Last Month's Same Day Retail"}
            ColorDark="bg-gradient-to-b from-[#ec82b6] to-[#D73585] col-span-1"
            Title={" LMSD "}
            Value={totalretaillmsd?.Total_retail_lmsd_count || 0}
            Padding={"p-2"}
            ImageSize={"w-10"}
          />

          {/* 3 → FULL ROW on mobile */}
          <RetailBreakupKPI
            image={total}
            ImageSize={"w-9 h-9"}
            title="Total Retail"
            padding={"p-2"}
            totalValue={ttlRetail || 0}
            newInvoice={invoice?.new || 0}
            cancelledInvoice={invoice?.cancelled || 0}
            directBilling={invoice?.direct_billing || 0}
            colorClass="bg-gradient-to-b from-[#3BCEC0] to-[#129CD2] col-span-2 lg:col-span-2"
            onClick={openModal}
          />

          {/* 4 */}
          <PriKPI
            Image={totallmtd}
            Alt={"Total Last Month Retail "}
            ColorDark="bg-gradient-to-b from-[#fcc574] to-[#BA7715] col-span-1"
            Title={"Total LM Retail"}
            Value={lmtd_retail?.LAST_MONTH_RETAIL || 0}
            Padding={"p-2"}
            ImageSize={"w-10"}
          />

          {/* 5 */}
          <PriKPI
            Image={lmtd}
            Alt={"Last Month Till Date Retail"}
            ColorDark="bg-gradient-to-b from-[#A78BFA] to-[#634DA6] col-span-1"
            Title={" LMTD"}
            Value={lmtd_retail?.LMTD_RETAIL || 0}
            Padding={"p-2"}
            ImageSize={"w-11"}
          />
        </section>

        <div
          className="w-full lg:w-[5%] rounded-lg p-2 bg-gradient-to-b from-rose-300 to-orange-200 flex justify-center items-center transition duration-300 ease-in-out transform hover:scale-105 cursor-pointer "
          onClick={toggleForm}
        >
          <button title="Click to Apply Filters">
            <TbFilterDown className="w-7 h-7 text-[#2A5775]" />
          </button>
        </div>
      </div>
      {isModalOpen && (
        <RetailTableDetailed closeModal={() => setIsModalOpen(false)} />
      )}
    </div>
  );
};
